import http from '@/lib/http'
import { useMutation, useQuery } from '@tanstack/react-query'

export type ReviewQuestionnaireAvailability = {
  available: boolean
  questionnaireHash: string | null
  title: string | null
  trigger: string | null
  requestStatus: string | null
  dueAt: string | null
  connectLink: string | null
}

export type SendReviewQuestionnaireResponse = {
  requestHash: string
  status: string
  dueAt: string | null
  alreadyOpen: boolean
}

async function getReviewQuestionnaire(orderHash: string): Promise<ReviewQuestionnaireAvailability> {
  return (await http.get(`/orders/${orderHash}/review-questionnaire`)) as ReviewQuestionnaireAvailability
}

async function sendReviewQuestionnaire(orderHash: string): Promise<SendReviewQuestionnaireResponse> {
  return (await http.post(`/orders/${orderHash}/review-questionnaire`, {})) as SendReviewQuestionnaireResponse
}

/**
 * Whether a review can be sent for this order, and where the current one got to.
 *
 * Only the API can answer this: a review is sendable from here only when it is
 * marked manual, and this app holds no questionnaire data to judge that with.
 */
export function useReviewQuestionnaire(orderHash: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['review-questionnaire', orderHash],
    queryFn: () => getReviewQuestionnaire(orderHash as string),
    enabled: enabled && !!orderHash
  })
}

export function useSendReviewQuestionnaire() {
  return useMutation({
    mutationFn: sendReviewQuestionnaire
  })
}
